import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2235_15694)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9998 7.99935C13.9998 4.68564 11.3135 1.99935 7.99984 1.99935C4.68613 1.99935 1.99984 4.68564 1.99984 7.99935C1.99984 11.3131 4.68613 13.9993 7.99984 13.9993C11.3135 13.9993 13.9998 11.3131 13.9998 7.99935ZM15.3332 7.99935C15.3332 12.0494 12.0499 15.3327 7.99984 15.3327C3.94975 15.3327 0.666504 12.0494 0.666504 7.99935C0.666504 3.94926 3.94975 0.666016 7.99984 0.666016C12.0499 0.666016 15.3332 3.94926 15.3332 7.99935Z",
				fill: "#9DA5B0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.3335 10.6673V8.00065C7.3335 7.63246 7.63197 7.33398 8.00016 7.33398C8.36835 7.33398 8.66683 7.63246 8.66683 8.00065V10.6673C8.66683 11.0355 8.36835 11.334 8.00016 11.334C7.63197 11.334 7.3335 11.0355 7.3335 10.6673Z",
				fill: "#9DA5B0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.00667 4.66602C8.37486 4.66602 8.67334 4.96449 8.67334 5.33268C8.67334 5.70087 8.37486 5.99935 8.00667 5.99935H8.00016C7.63197 5.99935 7.3335 5.70087 7.3335 5.33268C7.3335 4.96449 7.63197 4.66602 8.00016 4.66602H8.00667Z",
				fill: "#9DA5B0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2235_15694",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgInfo;
